import React from 'react';
import { ChevronLeft } from 'lucide-react';

function BackButton({ onClick, children }) {
    return (
        <button className="back-button" onClick={onClick}>
            <ChevronLeft className="back-button__icon" />
            {children}
        </button>
    );
}

export default BackButton;
